import { memo, useMemo } from 'react'
import { useActiveChatId } from '../../../../store'
import { useIsVoiceModeActive } from '../../../../store/atoms'
import { AnimatedLabel } from '../../../elements/AnimatedLabel'

export const InputPlaceholder = memo(() => {
  const activeChatId = useActiveChatId()
  const isVoiceModeActive = useIsVoiceModeActive()

  const inputPlaceholder = useMemo(() => {
    if (isVoiceModeActive) {
      return 'Asking Highlight with voice...'
    }
    if (activeChatId && window.__RENDERER_NAME === 'assistant') {
      return 'Keep chatting...'
    }
    return 'Ask Highlight anything'
  }, [isVoiceModeActive, activeChatId])

  return <AnimatedLabel label={inputPlaceholder} transitionMs={200} />
})
InputPlaceholder.displayName = 'InputPlaceholder'
